import { api } from '../../../servicesGlobais/api'
import type { NfMomentumItem } from '../tipos/nfMomentum'

export async function obterNfsMomentum(): Promise<NfMomentumItem[]> {
  return await api.get<NfMomentumItem[]>('/ConsultaNfMomentum')
}
